import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";

export const useTableColumnsUbicacionProducto = () => {

  const columnsUbicacionProducto = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: 'descripcion_producto',
        header: 'PRODUCTO',
        Cell: ({ row }) => (
          row.original.producto_data.descripcion
        ),
      },
      {
        accessorKey: 'producto',
        header: 'CODIGO PRODUCTO',
      },
      // {
      //   accessorKey: 'producto_data.contiene_serie',
      //   header: 'CONTIENE SERIE',
      // },
    ],
    [],
  );

  return {
    columnsUbicacionProducto,
  }
}